import Component from '../colorz/Component';

export default class AnnouncementBar extends Component {
	onInit(el) {
		this.el = el;
		this.elAnnBarTemp = this.el.querySelector('.c-announcement-bar--temp');
		this.elAnnBar = this.el.querySelector('.c-announcement-bar__slider');
		this.showCartDeliveryMessage = String(this.el.dataset.cartDelivery);
	}

	onReady() {
		this.setCookieCart();
		this.checkCookieCart();
	}

	onLoad() {
		this.elAnnBarTemp.classList.add('u-hidden');
		this.elAnnBar.classList.remove('u-hidden');
	}

	setCookieCart() {
		if (
			document.querySelector('#main-cart-footer') &&
			document.cookie.indexOf('cart-visited=') == -1
		) {
			document.cookie = 'cart-visited=1';
		}
	}

	checkCookieCart() {
		const cartVisited = document.cookie.includes('cart-visited=');
		const isCartPage = window.location.pathname === '/cart';

		if (!cartVisited) return;

		const shouldShowMessage =
			this.showCartDeliveryMessage === 'enable' ||
			(this.showCartDeliveryMessage === 'cart' && isCartPage);

		if (shouldShowMessage) {
			this.el.setAttribute('data-show-shipping-msg', 'true');
		}
	}
}
